module.exports = "/images/contract-cht-page-1.jpg?1ee64a8f3ddaa7dd4ce197bd5000820d";